// Podtemat 7 - dzialania laczne na liczbach wymiernych.
// Pierwszy typ pochodzi z egzaminu osmioklasisty.

import * as E8MixedNumberExpressionClosedTask from "./podtemat7_dzialania_laczne_wymierne_types/E8MixedNumberExpressionClosedTask";
import * as CombinedFractionTasks from "./podtemat7_dzialania_laczne_wymierne_types/CombinedFractionTasks";

export const registry = {
  E8MixedNumberExpressionClosedTask,
  ...CombinedFractionTasks.registry,
};

export function generateTasks() {
  return CombinedFractionTasks.generateTasks();
}

export function renderTask(task) {
  return registry[task.type].renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return registry[task.type].renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return registry[task.type].checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return registry[task.type].renderAnswer(task);
}

export function renderExplanation(task) {
  return registry[task.type].renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return registry[task.type].renderUserAnswer(userAnswer, task);
}
